import { getActiveByHirer } from '../services/sla-priority.service';

// Cache em nível de módulo das definições de SLA por prioridade do hirer.
// categoryMap: { [organizationcategoryid]: { [priorityid]: { servicetime, solutiontime } } }
// orgSlaMap:   { [organizationslaid]:      { [priorityid]: { servicetime, solutiontime } } }
let categoryMap = null;
let orgSlaMap = null;
let loadedAt = 0;
let loadingPromise = null;

const CLIENT_CACHE_TTL_MS = 5 * 60 * 1000; // acompanha o TTL do Redis no backend

async function loadMaps() {
  const result = await getActiveByHirer();
  const newCategoryMap = {};
  const newOrgSlaMap = {};

  if (result && result.success && Array.isArray(result.data)) {
    result.data.forEach(row => {
      const entry = {
        servicetime: row.servicetime != null && row.servicetime > 0 ? row.servicetime : null,
        solutiontime: row.solutiontime != null && row.solutiontime > 0 ? row.solutiontime : null,
      };
      if (row.slamode === 3 && row.organizationcategoryid != null) {
        if (!newCategoryMap[row.organizationcategoryid]) {
          newCategoryMap[row.organizationcategoryid] = {};
        }
        newCategoryMap[row.organizationcategoryid][row.priorityid] = entry;
      } else if (row.slamode === 2 && row.organizationslaid != null) {
        if (!newOrgSlaMap[row.organizationslaid]) {
          newOrgSlaMap[row.organizationslaid] = {};
        }
        newOrgSlaMap[row.organizationslaid][row.priorityid] = entry;
      }
    });
  }

  categoryMap = newCategoryMap;
  orgSlaMap = newOrgSlaMap;
  loadedAt = Date.now();
}

export async function ensureSlaPrioritiesLoaded() {
  if (categoryMap != null && Date.now() - loadedAt < CLIENT_CACHE_TTL_MS) {
    return;
  }
  if (loadingPromise == null) {
    loadingPromise = loadMaps()
      .catch(() => {
        // Falha na API: mantém mapas vazios; o cálculo segue o fluxo padrão
        categoryMap = categoryMap || {};
        orgSlaMap = orgSlaMap || {};
        loadedAt = Date.now();
      })
      .finally(() => {
        loadingPromise = null;
      });
  }
  return loadingPromise;
}

// Resolução síncrona: chamada dentro de getSlaAtendimento/getSlaSolucao.
// Retorna { servicetime, solutiontime } — campo null significa "sem definição
// por prioridade, seguir o fluxo padrão atual".
export function resolveSlaPriorityTimes(item) {
  const empty = { servicetime: null, solutiontime: null };

  console.log(categoryMap, item, 'resolveSlaPriorityTimes');
  // Autocorreção: se o mapa ainda não foi carregado (ou expirou), dispara a
  // recarga em background; esta chamada segue o fluxo padrão e as próximas
  // consultas já usam os dados atualizados
  if (categoryMap == null || Date.now() - loadedAt >= CLIENT_CACHE_TTL_MS) {
    ensureSlaPrioritiesLoaded();
  }

  if (categoryMap == null || item == null || item.priorityid == null) {
    return empty;
  }

  const category = item.organizationcategory;
  const categoryId = category != null ? category.id : null;

  // Regra 1: a categoria possui definição de SLA por prioridade — só ela é
  // considerada; se a prioridade do chamado não tiver entrada, segue o padrão.
  if (categoryId != null && categoryMap[categoryId] != null) {
    return categoryMap[categoryId][item.priorityid] || empty;
  }

  // Regra 2: categoria sem definição — verifica o organizationsla vinculado.
  const orgSla = category != null ? category.organizationsla : null;
  const orgSlaId = orgSla != null ? orgSla.id : null;

  if (orgSlaId != null && orgSlaMap[orgSlaId] != null) {
    return orgSlaMap[orgSlaId][item.priorityid] || empty;
  }

  return empty;
}
